import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'fun-dashboard-submenu',
  templateUrl: './dashboard-submenu.component.html',
  styleUrls: ['./dashboard-submenu.component.scss']
})
export class DashboardSubmenuComponent implements OnInit {

  @Input('page') page;
  @Output() public changeLevel = new EventEmitter<any>();

  slideOpts: any;

  constructor() { }

  ngOnInit() {
    this.createSlider();
  }

  createSlider() {
    let index: number;

    switch (this.page) {
      case 'dashboard':
        index = 0;
        break;
      case 'updates':
        index = 1;
        break;
      case 'movements':
        index = 2;
        break;
      case 'documentation':
        index = 3;
        break;
      case 'payment-calendar':
        index = 4;
        break;
    }
    this.slideOpts = {
      initialSlide: 0, // index
      speed: 1000,
      //width: 100,
      effect: 'slide', // slide, fade, cube, coverflow, flip
      slidesPerView: 4,//'auto',
      spaceBetween: 2,
      grabCursor: true,
      slideToClickedSlide: false, //this.isMobile,
      freeMode: true, //this.isMobile,
      //centeredSlides: true//this.isMobile,
    };
  }

  selected(url) {
    this.changeLevel.emit(url);
  }

}
